<template>
<div class="sidebar"  v-if="!$parent.isAdminPage($route.path, $route.name)">
      <nav class="sidebar-nav">
          <ul class="nav">
              <li class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                  <router-link to="/dashboard" exact class="nav-link">
                      <i class="icon-speedometer"></i> Dashboard
                  </router-link>
              </li>
              <li class="nav-item" :class="{'active-menu': isActiveMenu('(time-sheets)')}"
                  v-if="permissions.indexOf('timetracking_task_read') >= 0" >
                  <router-link :to="{path: '/time-sheets', query: {page: 1}}" class="nav-link">
                      <i class="fa fa-clock-o"></i> Time Sheet
                  </router-link>
              </li>

              <li class="nav-item" :class="{'active-menu': isActiveMenu('/workflow/all-my-tasks')}"
                  v-if="permissions.indexOf('workflow_all_my_tasks') >= 0">
                  <router-link :to="{path: '/workflow/all-my-tasks', query: { page: 1 }}" exact class="nav-link">
                      <i class="fa fa-tasks"></i> My Tasks
                  </router-link>
              </li>

              <li class="nav-item" :class="{'active-menu': isActiveMenu('/workflow/all-tasks')}"
                  v-if="permissions.indexOf('workflow_all_workflow_tasks') >= 0">
                  <router-link :to="{path: '/workflow/all-tasks', query: { page: 1 }}" exact class="nav-link">
                      <i class="fa fa-tasks"></i> All Tasks
                  </router-link>
              </li>

              <li class="nav-item" :class="{'active-menu': isActiveMenu('(clients)')}" v-if="permissions.indexOf('client_read') >= 0">
                  <router-link :to="{path: '/clients', query: { page: 1 }}" class="nav-link">
                      <i class="fa fa-users"></i> Clients
                  </router-link>
              </li>

              <li class="nav-item" :class="{'active-menu': isActiveMenu('(deadlines)')}" v-if="permissions.indexOf('see_all_deadlines') >= 0">
                  <router-link :to="{path: '/deadlines', query: { page: 1 }}" class="nav-link">
                      <i class="fa fa-clock-o"></i> Deadlines
                  </router-link>
              </li>


              <li class="nav-item nav-dropdown" :class="{'open': isActiveMenuGroup(reports_paths)}" v-if="permissions.indexOf('reports_read') >= 0">
                  <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-area-chart"></i>Reports</a>
                  <ul class="nav-dropdown-items">
                      <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/user-tasks)')}">
                          <router-link :to="{path: '/reports/user-tasks', query: {page: 1}}" class="nav-link">
                              <i class="fa fa-tasks"></i> User Tasks
                          </router-link>
                      </li>
                      <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/completed-tasks)')}">
                          <router-link :to="{path: '/reports/completed-tasks', query: {page: 1}}" class="nav-link">
                              <i class="fa fa-calendar-check-o"></i> Completed Tasks
                          </router-link>
                      </li>
                      <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/client-revenue)')}">
                          <router-link :to="{path: '/reports/client-revenue', query: {page: 1}}" class="nav-link">
                              <i class="fa fa-dollar"></i> Client Revenue
                          </router-link>
                      </li>
                      <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/weekly-time)')}">
                          <router-link :to="{path: '/reports/weekly-time', query: {page: 1}}" class="nav-link">
                              <i class="fa fa-clock-o"></i> Weekly Time
                          </router-link>
                      </li>
                  </ul>
              </li>
              <li class="nav-item nav-dropdown" :class="{'open': isActiveMenuGroup(settings_paths)}" v-if="permissions.indexOf('company_management') >= 0">
                  <a href="#" class="nav-link nav-dropdown-toggle"><i class="icon-wrench"></i>Settings</a>
                  <ul class="nav-dropdown-items">
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(settings)')}">
                      <router-link :to="{path: '/settings'}" class="nav-link">
                          <i class="fa fa-cog"></i> Settings
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(users)')}">
                      <router-link :to="{path: '/users'}" class="nav-link">
                          <i class="fa fa-users"></i> Manage Users
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(roles)')}">
                      <router-link :to="{path: '/roles'}" class="nav-link">
                          <i class="fa fa-building"></i> Manage Roles
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(fee-types)')}"
                      v-if="permissions.indexOf('timetracking_cost_type_read') >= 0">
                      <router-link :to="{path: '/fee-types', query: {page: 1}}" class="nav-link">
                          <i class="fa fa-dollar"></i> Fee Type
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(task-types)')}"
                      v-if="permissions.indexOf('timetracking_task_type_read') >= 0" >
                      <router-link :to="{path: '/task-types', query: {page: 1}}" class="nav-link">
                          <i class="fa fa-align-justify"></i> Task Type
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(checklists)')}"
                      v-if="permissions.indexOf('workflow_checklist_index') >= 0">
                      <router-link :to="{path: '/checklists', query: { page: 1 }}" exact class="nav-link">
                          <i class="fa fa-check-square-o"></i> Checklists
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('/workflow')}" v-if="permissions.indexOf('workflow_index') >= 0">
                      <router-link :to="{path: '/workflow', query: { page: 1 }}" exact class="nav-link">
                          <i class="fa fa-recycle"></i> Workflow templates
                      </router-link>
                    </li>
                  </ul>
              </li>
              <li class="nav-item">
                  <a href="http://optimpractice.com/support" class="nav-link" target="_blank">
                      <i class="fa fa-support"></i> Support
                  </a>
              </li>
              <li class="nav-item">
                  <a href="http://optimpractice.com/getting-started" class="nav-link" target="_blank">
                      <i class="fa fa-rocket"></i> Getting Started
                  </a>
              </li>
          </ul>
      </nav>
    </div>
</template>

<script>
export default {
  data () {
    return {
      permissions: (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')).permissions : [],
      transaction_paths: ['/time-tasks', '/workflow', '/workflow/all-my-tasks'],
      reports_paths: ['/reports/user-tasks', '/reports/completed-tasks', '/reports/client-revenue', '/reports/weekly-time'],
      settings_paths: ['/settings', '/users', '/roles', '/fee-types', '/task-types', '/checklists']
    }
  },
  beforeCreate () {
    this.permissions = (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')).permissions : []
  },
  methods: {
    isActiveMenuGroup (menuitems = []) {
      for (var i in menuitems) {
        let pattern = new RegExp(menuitems[i])
        if (pattern.test(this.$route.path)) {
          return true
        }
      }
    },
    isActiveMenu (path) {
      var pattern = new RegExp(path)
      if (path === '/workflow' || path === '/workflow/all-my-tasks') {
        return path === this.$route.path
      } else {
        return pattern.test(this.$route.path)
      }
    }
  }
}
</script>
<style>
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu {
        background: #03BFA5 !important;
    }
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu a:hover {
        background: #04d1b2 !important;
    }
</style>


// WEBPACK FOOTER //
// Sidebar.vue?efab7852